import * as API from '@siloreal:shared:api';

const SILOBAG_ARCHIVE_ENDPOINT = '/silobags/archive';

export type ArchiveSilobagServiceContract = {
  query: string | number;
  signal?: AbortSignal;
};

export type ArchiveSilobagResponse = unknown;

export async function archiveSilobagService(
  contract: ArchiveSilobagServiceContract
): Promise<ArchiveSilobagResponse> {
  const query = encodeURIComponent(String(contract.query));
  const { data } = await API.http.fetch.post<ArchiveSilobagResponse>(`${SILOBAG_ARCHIVE_ENDPOINT}/${query}`, {
    signal: contract.signal,
  });

  return data;
}
